import type { INotification } from 'BreetHelpers';
import type { Ref } from 'react';

export const groupByCreatedAt = (itemArgs: INotification[]) => {
	const groups = itemArgs.reduce<Record<string, INotification[]>>((acc, item) => {
		const dateKey = new Date(item.createdAt).toISOString().split('T')[0];
		if (!(dateKey in acc)) acc[dateKey] = [];
		acc[dateKey].push(item);
		return acc;
	}, {});

	return Object.entries(groups).map(([date, items]) => ({
		date,
		items,
	}));
};

export interface INotificationItem extends INotification {
	selected?: boolean;
	onSelect?: () => void;
	deleteItem?: () => void;
	markItemAsRead?: () => void;
	deleteNotificationsLoading: boolean;
	targetRef?: Ref<HTMLDivElement>;
}
